/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useRef, useState } from "react";

// Router
import { useLocation, useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  beneCategories,
  uploadImages,
} from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";

import { reimbursementTxnRequest } from "../../../redux/features/reimbursementTransaction";

// Utils
import ICONS from "../../../assets/Icons";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../utils/configurationProvider";

// Components
import AmountToWords from "../../../components/_utils/AmountToWords";
import PrimaryStepper from "../../../components/_utils/CommonSteppers/PrimaryStepper";
import SVGComponent from "../../../components/_utils/SVGComponent";
import ReimbursementRequestAccount from "../../../components/ReimbursementRequest/ReimbursementRequestAccount";
import ReimbursementRequestTxnAdditionalDetails from "../../../components/ReimbursementRequest/ReimbursementRequestTxnAdditionalDetails";
import ReimbursementRequestTxnConfirm from "../../../components/ReimbursementRequest/ReimbursementRequestTxnConfirm";
import ReimbursementRequestTxnTransferAmount from "../../../components/ReimbursementRequest/ReimbursementRequestTxnTransferAmount";

import "./index.css";

const ReimbursementTxnRequestCreate = () => {
  //  useDispatch, useNavigate, useLocation
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //  useRef
  const scrollIt = useRef(null);
  const openOwner = false;
  //  useState
  const [endDate, setEndDate] = useState({});
  const [quantity, setQuantity] = useState({});
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [mapingCat, setMapingCat] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [hyperLinks, setHyperLinks] = useState({});
  const [quantities, setQuantities] = useState({});
  const [direction, setDirection] = useState(null);
  const [catSelect, setCatSelect] = useState(false);
  const [startDateCal, setStartDateCal] = useState({});
  const [showYearDrop, setShowYearDrop] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [amountInWords, setAmountInWords] = useState("");
  const [selectedValue, setSelectedValue] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [removeClassName, setRemoveClassName] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [nextButtonEnabled, BenEnableNextButton] = useState(true);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [isSingleDateSelected, setIsSingleDateSelected] = useState(false);
  const [createActive, setCreateActive] = useState(false);
  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: 0,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    expenseType: "",
    date: "",
    description: "",
    uploadFile: "",
    prevImage: [],
    labels: [],
    ownerLabels: [],
  });
  const [category, setCategory] = useState(
    txnPayLoad?.categories ? txnPayLoad?.categories?.split(",") : [],
  );

  //  useSelector
  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  //  Constants
  const steps = [
    "Destination account",
    "Additional details",
    "Transfer amount",
    "Confirm and create",
  ];

  //  Callbacks

  const animationClass =
    direction === "next" ? "animate-slide-next" : "animate-slide-prev";

  //  useEffect
  useEffect(() => {
    dispatch(beneCategories());
  }, [dispatch]);

  const handleKeyDown = (event) => {
    if (
      event.target.tagName === "INPUT" ||
      event.target.tagName === "TEXTAREA"
    ) {
      if (event.key === "Tab") {
        event.preventDefault();
      }
    } else if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const formatDate = (date) => {
    return `${date.getDate()}/${date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const handleCreateTransaction = async () => {
    setCreateActive(true);

    let haveImage = txnPayLoad?.mergeCategory?.some((val) => {
      return val?.data_type === "upload" && val?.value !== "Not Given";
    });

    let storeData;

    let add = 0;

    const fileUpload = await dispatch(uploadImages(txnPayLoad.uploadFile));

    if (haveImage) {
      const responseUpload = await Promise.all(
        Object.values(uploadedFiles).map((file) =>
          dispatch(uploadImages(file)),
        ),
      );
      if (responseUpload) {
        storeData = selectedCategory?.configuration?.data?.map((val) => {
          if (additionalData[val?.name]) {
            const dataValue = additionalData[val?.name];
            if (val?.data_type === "numeric") {
              const integerValue = parseInt(dataValue, 10);
              if (!isNaN(integerValue)) {
                return { ...val, value: integerValue };
              } else {
                throw new Error(
                  `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
                );
              }
            } else if (val?.data_type === "upload") {
              const { description, ...rest } = val;
              return { ...rest, value: responseUpload[add++]?.payload };
            } else if (val?.data_type === "toggle") {
              const { description, ...rest } = val;
              return { ...rest, value: dataValue };
            } else {
              return { ...val, value: dataValue };
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest };
          }
          return val;
        });
      }
    } else {
      storeData = selectedCategory?.configuration?.data?.map((val) => {
        if (additionalData[val?.name]) {
          const dataValue = additionalData[val?.name];
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              throw new Error(
                `Value '${dataValue}' is not a valid integer for category '${val?.name}'`,
              );
            }
          } else if (val?.data_type === "toggle") {
            const { description, ...rest } = val;
            return { ...rest, value: dataValue };
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "toggle") {
          const { description, ...rest } = val;
          return { ...rest };
        }
        return val;
      });
    }

    const response1 = await dispatch(
      reimbursementTxnRequest({
        expense_type: txnPayLoad.expenseType,
        amount: txnPayLoad.amount,
        // beneficiary_account_id: txnPayLoad.beneAccountId,
        reimbursement_date: formatDate(new Date(txnPayLoad.date)),
        uploaded_file_data: fileUpload?.payload,
        category: selectedCategory?.name,
        additional_data: storeData,
        labels: [
          ...(txnPayLoad.labels || []),
          ...(txnPayLoad.ownerLabels || []),
        ],
        description: txnPayLoad?.description,

        // owner_account_id: txnPayLoad.ownerId,
      }),
    );

    if (response1?.error?.message !== "Rejected") {
      let transactionId = response1.payload?.request[0]?.request_id;

      setCreateActive(false);
      navigate(
        `/reimbursement_transaction_dashboard/create_reimbursement_transactions/success/${transactionId}`,
        {
          replace: true,
        },
      );
    } else {
      navigate(
        "/reimbursement_transaction_dashboard/create_reimbursement_transactions/failed",
        {
          replace: true,
        },
      );

      setCreateActive(false);
    }
  };

  const handleNext = () => {
    if (activeStep === 3) {
      if (!createActive) {
        handleCreateTransaction();
      }
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);

      setDirection("next");
      setRemoveClassName(false);

      setTimeout(() => {
        setRemoveClassName(true);
      }, IntervalConfiguration?.intervalMedium);

      setTimeout(() => {}, IntervalConfiguration?.intervalSmaller);
    }
  };

  useEffect(() => {
    const handleEnterKeyPress = (e) => {
      if (e.key === "Enter" && activeStep === 3) {
        e.preventDefault();
        handleCreateTransaction();
      }
    };

    document.addEventListener("keydown", handleEnterKeyPress);
    return () => {
      document.removeEventListener("keydown", handleEnterKeyPress);
    };
  }, [activeStep, handleCreateTransaction]);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[0],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[1],
    },
    {
      previousText: "Previous",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled,
      stepperText: steps[2],
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--positive-act)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--text-primary)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled: !nextButtonEnabled && !createActive,
      stepperText: steps[GlobalConfiguration.accountminLength],
    },
  ];

  const renderCreateTxn = () => {
    switch (activeStep) {
      case 0:
        return (
          <ReimbursementRequestAccount
            catSelect={catSelect}
            setCatSelect={setCatSelect}
            mapingCat={mapingCat}
            category={category}
            setCategory={setCategory}
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            handleCategorySelect={handleCategory}
            categories={categories}
            setAdditionalData={setAdditionalData}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setSelectedValue={setSelectedValue}
            setSelectedValueMonth={setSelectedValueMonth}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setStartDateCal={setStartDateCal}
            setIsSingleDateSelected={setIsSingleDateSelected}
            setQuantities={setQuantities}
            setAmountInWords={setAmountInWords}
            setHyperLink={setHyperLinks}
            setPreviewImages={setPreviewImages}
            setUploadedFiles={setUploadedFiles}
            setTimeData={setTimeData}
            setMapingCat={setMapingCat}
            setLabelsAcc={() => {}}
          />
        );
      case 1:
        return (
          <ReimbursementRequestTxnAdditionalDetails
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            additionalData={additionalData}
            setAdditionalData={setAdditionalData}
            BenEnableNextButton={BenEnableNextButton}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            selectedValueMonth={selectedValueMonth}
            setSelectedValueMonth={setSelectedValueMonth}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            setShowDatePicker={() => {}}
            startDateCal={startDateCal}
            setStartDateCal={setStartDateCal}
            isSingleDateSelected={isSingleDateSelected}
            setIsSingleDateSelected={setIsSingleDateSelected}
            quantities={quantities}
            setQuantities={setQuantities}
            hyperLink={hyperLinks}
            setHyperLink={setHyperLinks}
            uploadedFiles={uploadedFiles}
            setUploadedFiles={setUploadedFiles}
            setPreviewImages={setPreviewImages}
            timeData={timeData}
            setTimeData={setTimeData}
            setQuantity={setQuantity}
            quantity={quantity}
            setShowYearDrop={setShowYearDrop}
            showYearDrop={showYearDrop}
          />
        );
      case 2:
        return (
          <ReimbursementRequestTxnTransferAmount
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            amountInWords={amountInWords}
            setAmountInWords={setAmountInWords}
          />
        );
      case 3:
        return (
          <ReimbursementRequestTxnConfirm
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            selectedCategory={selectedCategory}
            previewImages={previewImages}
          />
        );
      default:
        return null;
    }
  };

  const isValidHttpUrl = (url) => {
    const httpRegex =
      /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(:[0-9]{1,5})?(\/.*)?$/;
    return httpRegex.test(url);
  };

  useEffect(() => {
    const configData = txnPayLoad?.selectedCategory?.configuration?.data || [];
    const mergeCategory = txnPayLoad?.mergeCategory || [];

    const mandatoryFields = configData.filter((val) => val?.mandatory === "Y");
    const filledMandatoryFields = mergeCategory.filter(
      (val) =>
        val?.mandatory === "Y" &&
        (val?.data_type === "from_year_to_year"
          ? val?.value?.from && val?.value?.to
          : val?.value),
    );

    const isMandatoryFieldsFilled =
      mandatoryFields.length === filledMandatoryFields.length;

    const isHyperlinkHave = mergeCategory?.some(
      (val) => val?.data_type === "hyperlink",
    );

    const isHyperlinkvalid = mergeCategory
      ?.filter((val) => {
        return val?.data_type === "hyperlink" && val?.value !== "";
      })
      .every((val) => isValidHttpUrl(val?.value));

    const isHyperLink = isHyperlinkHave && isHyperlinkvalid;

    const isAmountValid = txnPayLoad?.amount > 0;

    let isStepValid = false;

    switch (activeStep) {
      case 0:
        isStepValid =
          !!txnPayLoad?.beneAccountId && !!txnPayLoad?.selectedCategory;
        break;

      case 1:
        isStepValid =
          txnPayLoad?.date &&
          txnPayLoad?.expenseType?.length >=
            GlobalConfiguration.accountminLength &&
          !Array.isArray(txnPayLoad?.uploadFile) &&
          txnPayLoad?.uploadFile &&
          isMandatoryFieldsFilled &&
          (!isHyperlinkHave || isHyperLink);
        break;

      case 2:
        isStepValid = isAmountValid;
        break;

      case 3:
        isStepValid = true;
        break;
      default:
        break;
    }

    BenEnableNextButton(!isStepValid);
  }, [activeStep, txnPayLoad, hyperLinks]);

  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prevActiveStep) =>
        prevActiveStep ? prevActiveStep - 1 : 0,
      );

      setDirection("previous");

      setRemoveClassName(false);
      setTimeout(() => {
        setRemoveClassName(true);
      }, 1000);
      setTimeout(() => {}, 500);
    }
  };
  useEffect(() => {
    if (
      location?.state?.txnDetails?.reminderAmount !== "" &&
      txnPayLoad?.amount === "" &&
      location?.state !== null
    ) {
      let amountWords =
        AmountToWords(
          parseFloat(location?.state?.txnDetails?.reminderAmount),
        ) || "";
      setAmountInWords(
        location?.state?.txnDetails?.reminderAmount >= 1 &&
          location?.state?.txnDetails?.reminderAmount <= 9
          ? amountWords.replace("rupees", "rupee")
          : amountWords,
      );
      setTxnPayLoad((prev) => {
        return {
          ...prev,
          amount: location?.state?.txnDetails?.reminderAmount,
          amountInWords:
            location?.state?.txnDetails?.reminderAmount >= 1 &&
            location?.state?.txnDetails?.reminderAmount <= 9
              ? amountWords.replace("rupees", "rupee")
              : amountWords,
        };
      });
    }
  }, [location]);
  const handleCategory = (selectedCategoryData) => {
    setSelectedCategory(selectedCategoryData);
  };

  const [isStepper, setIsStepper] = useState(window.innerWidth <= 800);

  useEffect(() => {
    const handleResize = () => {
      setIsStepper(window.innerWidth <= 800);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const [uploadedFiles, setUploadedFiles] = useState({});
  const [previewImages, setPreviewImages] = useState({});

  useEffect(() => {
    scrollIt.current.scrollTop = 0;
  }, [activeStep]);

  return (
    <div
      className="w-width-full flex justify-start items-center flex-col bg-primary-bg overflow-y-auto"
      style={{
        height: openOwner ? "var(--height-full)" : "var(--full-height)",
      }}
    >
      <div className="w-width-full hidden Qsmd:block h-navbar-breadcrumb-height Qlg:bg-transparent bg-primary-nav flex-shrink-0"></div>
      <div className="bene_crt_reminder_header left-left-base z-z-index-loader flex justify-center items-center flex-col lg:flex-col-reverse w-width-full lg:py-padding-base bottom-bottom-base top-auto lg:top-top-base lg:bottom-auto  Qsmd:bg-transparent">
        <PrimaryStepper
          activeStep={activeStep}
          handleForwardAction={handleNext}
          handleBackwardAction={handleBack}
          dataArray={dataArray}
        />
      </div>

      {isStepper && (
        <>
          <div className="flex items-center w-full-width h-mobile-create-header bg-primary-nav p-padding-md top-top-base z-z-index-header shadow-box-shadow-bottom">
            <div
              className="cursor-pointer"
              onClick={() => {
                if (activeStep === 0) {
                  navigate("/reimbursement_transaction_dashboard");
                } else {
                  navigate(-1);
                }
              }}
            >
              <SVGComponent
                url={ICONS?.ARROW_LEFT_WHITE}
                color={"var(--text-primary)"}
                height={"var(--icon-md)"}
                width={"var(--icon-md)"}
                alt="Arrow"
              />
            </div>
            <div className="flex flex-col ml-margin-md">
              <div className="text-text-primary text-base">
                Reimbursement request
              </div>

              <>
                <div className="text-text-secondary text-xs">
                  {steps[activeStep] || ""}
                </div>
              </>
            </div>
          </div>
        </>
      )}

      <div className="overflow-y-auto overflow-x-hidden w-width-full h-height-full">
        <div className="max-w-tab-width-normal mx-auto overflow-hidden h-full flex flex-col items-center relative w-width-full">
          <>
            <div
              ref={scrollIt}
              className={`w-width-full h-height-full overflow-y-auto scroll-ref-div no-scrollbar  ${
                activeStep === GlobalConfiguration.lengthCheckZero &&
                direction === "next"
                  ? ""
                  : removeClassName === true
                    ? ""
                    : animationClass
              }`}
            >
              {renderCreateTxn()}
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReimbursementTxnRequestCreate;
